/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Export Video - Select Folder" |
*
* @param {Video_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_select_folder_title = /** @type {((inputs?: Video_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la video - Selectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video exportieren – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta video - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar vídeo - Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出视频 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオのエクスポート - フォルダの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात करें - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar vídeo - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Export Video - Select Folder")
});